import { render, staticRenderFns } from "./reportGroups.vue?vue&type=template&id=77becf7e"
import script from "./reportGroups.vue?vue&type=script&lang=js"
export * from "./reportGroups.vue?vue&type=script&lang=js"
import style0 from "./reportGroups.vue?vue&type=style&index=0&id=77becf7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports